import script from "./HomeContent5-projects.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeContent5-projects.vue?vue&type=script&setup=true&lang=js"

import "./HomeContent5-projects.vue?vue&type=style&index=0&id=009e8d10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-009e8d10"]])

export default __exports__